import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComparativeSdsnComponent } from './comparative-sdsn.component';
import { MatIconModule } from '@angular/material/icon';




@NgModule({
  declarations: [
    ComparativeSdsnComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [
    ComparativeSdsnComponent
  ]
})
export class ComparativeSdsnModule { }